import { render } from "./HeroPaymentStatus.vue?vue&type=template&id=22a870ee&scoped=true"
import script from "./HeroPaymentStatus.vue?vue&type=script&lang=js"
export * from "./HeroPaymentStatus.vue?vue&type=script&lang=js"

import "./HeroPaymentStatus.vue?vue&type=style&index=0&id=22a870ee&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a870ee"]])

export default __exports__